import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Clock, MapPin, Shirt } from 'lucide-react';

const DetailsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const details = [
    {
      icon: Clock,
      title: 'Hora',
      content: '17:00 h',
      testId: 'detail-time'
    },
    {
      icon: MapPin,
      title: 'Lugar',
      content: 'El Prat Verd',
      subtitle: 'Malla, Cataluña',
      testId: 'detail-location'
    },
    {
      icon: Shirt,
      title: 'Código de vestimenta',
      content: 'Formal',
      testId: 'detail-dresscode'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  return (
    <section 
      ref={ref}
      className="py-16 md:py-20 px-6 bg-gradient-to-b from-[#F5F0EB] via-[#F5F0EB] to-[#F9F7F2]"
      data-testid="details-section"
    >
      <motion.div
        className="max-w-4xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        {/* Section Title */}
        <motion.div className="text-center mb-12 md:mb-14" variants={itemVariants}>
          <span className="font-accent text-2xl md:text-3xl text-[#CCA598]">Los detalles</span>
          <h2 className="font-heading text-3xl md:text-4xl text-[#5D4037] mt-1">
            Información del evento
          </h2>
        </motion.div>

        {/* Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {details.map((detail, index) => (
            <motion.div
              key={index}
              className="text-center p-6 bg-[#F9F7F2]/60 rounded-sm"
              variants={itemVariants}
              data-testid={detail.testId}
            >
              {/* Icon Container */}
              <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-[#CCA598]/20 to-[#D7CCC8]/30 mb-4 shadow-sm">
                <detail.icon className="w-6 h-6 md:w-7 md:h-7 text-[#8D6E63]" strokeWidth={1.5} />
              </div>
              
              {/* Title */}
              <h3 className="font-body text-xs tracking-[0.18em] uppercase text-[#8D6E63] mb-2">
                {detail.title}
              </h3>
              
              {/* Content */}
              <p className="font-heading text-xl md:text-2xl text-[#5D4037]">
                {detail.content}
              </p>
              
              {/* Subtitle if exists */}
              {detail.subtitle && (
                <p className="font-body text-sm text-[#8D6E63] mt-1">
                  {detail.subtitle}
                </p>
              )}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default DetailsSection;
